import { ILanguageProvider } from "./Interfaces";

export class DefaultLanguageProvider implements ILanguageProvider
{
    private storageKey = 'iconics.localisation.currentLanguage.ffcae1b4-0f92-4486-a84a-ee71f7342685';

    public getBrowserLanguages(): Promise<string[]>
    {
        return Promise.resolve(navigator.languages.map(i => i));
    }

    public getCurrent(): Promise<string>
    {
        const value = localStorage.getItem(this.storageKey) ?? '';
        return Promise.resolve(value);
    }

    public setCurrent(value: string): Promise<void>
    {
        localStorage.setItem(this.storageKey, value);
        return Promise.resolve();
    }
}
